// ============================================
// EXTRACTORFEATURES.JS — Extrae 5-7 caracteristicas clave de un producto
// ============================================
// Estrategia:
// 1) Si el producto trae caracteristicas/atributos/specifications estructuradas
//    (objeto plano), las usa directamente.
// 2) Si no alcanzan 4, complementa escaneando con regex el texto descriptivo.

const ETIQUETAS_RELEVANTES = [
  { regex: /resoluci/i, etiqueta: 'Resolucion' },
  { regex: /megapixel|megapíxel|megapixeles|\bmp\b/i, etiqueta: 'Resolucion' },
  { regex: /lente|lens|focal/i, etiqueta: 'Lente' },
  { regex: /vision nocturna|visión nocturna|infrarroj|\bir\b|night vision|smart ir/i, etiqueta: 'Vision IR' },
  { regex: /ip6[5-9]|ip 6[5-9]|ipx|protección ip|proteccion ip/i, etiqueta: 'Proteccion' },
  { regex: /h\.?26[45]|hevc|compresi/i, etiqueta: 'Compresion' },
  { regex: /poe|802\.3|alimentación|alimentacion/i, etiqueta: 'Alimentacion' },
  { regex: /angulo|ángulo|fov|field of view/i, etiqueta: 'Angulo' },
  { regex: /micrófono|microfono|audio integrado|builtin audio/i, etiqueta: 'Audio' },
  { regex: /colorvu|color night|dual light/i, etiqueta: 'Color noche' },
  { regex: /\bwdr\b|rango dinamico|rango dinámico/i, etiqueta: 'WDR' },
  { regex: /onvif/i, etiqueta: 'ONVIF' },
  { regex: /microsd|micro sd|tarjeta sd/i, etiqueta: 'MicroSD' },
  { regex: /\bptz\b|pan tilt|zoom optic|zoom óptic/i, etiqueta: 'PTZ' },
  { regex: /\bdomo\b|\bbullet\b|\bbala\b|\bturret\b|\bfisheye\b/i, etiqueta: 'Tipo' },
];

function limpiarTexto(texto) {
  if (!texto) return '';
  return String(texto)
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function extraerFeatures(producto) {
  if (!producto) return [];

  const estructuradas = extraerDeCaracteristicas(producto);
  if (estructuradas.length >= 4) return estructuradas.slice(0, 6);

  const textoCompleto = limpiarTexto([
    producto.titulo,
    producto.nombre,
    producto.descripcion,
    producto.descripcion_corta,
    typeof producto.caracteristicas === 'string' ? producto.caracteristicas : '',
    safeStringify(producto.atributos),
    safeStringify(producto.specifications),
  ].filter(Boolean).join(' '));

  const desdeTexto = extraerDeTexto(textoCompleto);

  const todas = [...estructuradas, ...desdeTexto];
  const vistas = new Set();
  const unicas = [];
  for (const f of todas) {
    const k = (f.etiqueta || '').toLowerCase();
    if (vistas.has(k)) continue;
    vistas.add(k);
    unicas.push(f);
  }
  return unicas.slice(0, 6);
}

function safeStringify(v) {
  if (!v) return '';
  if (typeof v === 'string') return v;
  try { return JSON.stringify(v); } catch { return ''; }
}

function extraerDeCaracteristicas(producto) {
  const out = [];
  const carac = producto.caracteristicas || producto.atributos || producto.specifications || null;
  if (!carac || typeof carac !== 'object' || Array.isArray(carac)) return out;

  for (const [key, value] of Object.entries(carac)) {
    if (out.length >= 6) break;
    if (value == null) continue;
    if (typeof value === 'object') continue;
    const str = limpiarTexto(value);
    if (!str || str.length > 80) continue;
    out.push({
      etiqueta: limpiarTexto(key).slice(0, 30),
      valor: str.slice(0, 60),
    });
  }
  return out;
}

function extraerDeTexto(texto) {
  if (!texto) return [];
  const out = [];
  const yaPuestas = new Set();
  for (const regla of ETIQUETAS_RELEVANTES) {
    if (yaPuestas.has(regla.etiqueta)) continue;
    const re = new RegExp('([^.\\n]*' + regla.regex.source + '[^.\\n]*)', 'i');
    const match = texto.match(re);
    if (!match) continue;
    const fragmento = match[1].trim().slice(0, 80);
    if (fragmento.length <= 5) continue;
    out.push({ etiqueta: regla.etiqueta, valor: fragmento });
    yaPuestas.add(regla.etiqueta);
  }
  return out;
}
